var _rect, _path, _path2, _rect2;
const _excluded = ["svgRef", "title"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import React from "react";
const SvgGift = _ref => {
  let {
      svgRef,
      title
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 47,
    height: 47,
    rx: 23.5,
    fill: "white"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M29.25 21H18.75C17.9216 21 17.25 21.6716 17.25 22.5V30C17.25 30.8284 17.9216 31.5 18.75 31.5H29.25C30.0784 31.5 30.75 30.8284 30.75 30V22.5C30.75 21.6716 30.0784 21 29.25 21Z",
    stroke: "#381E42",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M30.75 26.25H17.25M24 18.75C24 18.305 23.868 17.87 23.6208 17.5C23.3736 17.13 23.0222 16.8416 22.611 16.6713C22.1999 16.501 21.7475 16.4564 21.311 16.5432C20.8746 16.6301 20.4737 16.8443 20.159 17.159C19.8443 17.4737 19.6301 17.8746 19.5432 18.311C19.4564 18.7475 19.501 19.1999 19.6713 19.611C19.8416 20.0222 20.13 20.3736 20.5 20.6208C20.87 20.868 21.305 21 21.75 21L24 18.75ZM26.25 21C26.695 21 27.13 20.868 27.5 20.6208C27.87 20.3736 28.1584 20.0222 28.3287 19.611C28.499 19.1999 28.5436 18.7475 28.4568 18.311C28.37 17.8746 28.1557 17.4737 27.841 17.159C27.5263 16.8443 27.1254 16.6301 26.689 16.5432C26.2525 16.4564 25.8001 16.501 25.389 16.6713C24.9778 16.8416 24.6264 17.13 24.3792 17.5C24.132 17.87 24 18.305 24 18.75L26.25 21ZM24 18.75V31.5V18.75Z",
    stroke: "#381E42",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 47,
    height: 47,
    rx: 23.5,
    stroke: "#E9F3F6"
  })));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgGift, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/gift.3d0f8917.svg";
export { ForwardRef as ReactComponent };